import React from 'react';
import usePlacesAutocompleteService, {
  usePlacesAutocompleteServiceConfig,
} from 'react-google-autocomplete/lib/usePlacesAutocompleteService';

export const useHook = (
  autocomplete_options: usePlacesAutocompleteServiceConfig,
) => {
  const autocomplete = usePlacesAutocompleteService(autocomplete_options);

  const [predictions, setPredictions] = React.useState<
    google.maps.places.AutocompletePrediction[]
  >([]);

  React.useEffect(() => {
    if (autocomplete.placePredictions.length > 0) {
      setPredictions(autocomplete.placePredictions);
    }
  }, [autocomplete.placePredictions]);

  return {
    predictions,
    resetPredictions: () => setPredictions([]),
    getPredictions: autocomplete.getPlacePredictions,
  };
};
